<script lang="ts" setup>
import MediaVideo from '@fondof-ui/components/media/MediaVideo.vue'
import type { MediaVideoProps } from '@fondof-ui/components/media/types'

import { PlayIcon } from '@fond-of/satch-icons'

const props = withDefaults(defineProps<MediaVideoProps>(), {
  showPlayButton: true,
})
</script>

<template>
  <MediaVideo v-bind="props">
    <template #playIcon>
      <div
        class="border-primary text-primary absolute left-1/2 top-1/2 z-10 flex -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full border-2 p-3"
      >
        <PlayIcon class="h-10 w-10" />
      </div>
    </template>
  </MediaVideo>
</template>
